<template>
	<li @click="itemClicked">
		<slot :item="item">
			<div class="cm-item row no-gutters">
				<div :class="iconClassNames">
					<icon v-if="item.icon" :icon="item.icon" />
				</div>
				<div class="col cm-title">
					{{ item.title }}
				</div>
				<div class="col-auto cm-shortcut mx-3" v-if="item.shortcut">
					{{ shortcutDisplay }}
				</div>
			</div>
		</slot>
	</li>
</template>
<script>
	export default {
		props: {
			title: { type: String, required: true },
			handler: { type: Function, required: true },
			icon: { type: [String, Object, Array] },
			iconCss: { type: String, default: '' },
			shortcut: { type: [String, Object] }
		},
		data() {
			return {

			}
		},
		computed: {
			item() {
				return {
					title: this.title,
					handler: this.handler,
					icon: this.icon,
					iconCss: this.iconCss,
					shortcut: this.shortcut
				}
			},
			iconClassNames() {
				return ['col-auto cm-icon mx-3', this.iconCss].join(' ')
			},
			shortcutDisplay() {
				if (this.shortcut) {
					switch (typeof this.shortcut) {
						case 'object':
							let arr = []
							let sc = this.shortcut

							if (sc.keyCode > 0) {
								if (sc.ctrlKey === true) {
									arr.push('Ctrl')
								}
								if (sc.shiftKey === true) {
									arr.push('Shift')
								}
								if (sc.altKey === true) {
									arr.push('Alt')
								}

								let key = sc.keyCode
								let keyChar = String.fromKeyCode(key)
								keyChar = keyChar || ''

								arr.push(keyChar)
								return arr.join(' + ')
							}
							break
						case 'string':
							return this.shortcut
						default:
							return this.shortcut
					}
				}

				return undefined
			}
		},
		created() {

		},
		mounted() {
			this.$parent.children.push(this)
		},
		methods: {
			itemClicked(e) {
				if (this.handler) {
					this.handler(this.item, e)
				}
			}
		},
	}
</script>
<style></style>
